// src/pages/StorylanePage.jsx

import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
  page: {
    padding: '2rem',
    maxWidth: 1100,
    margin: '0 auto',
  },
  header: {
    marginBottom: '2rem',
  },
  title: {
    fontSize: '1.75rem',
    fontWeight: 700,
    color: 'var(--ka-navy)',
    margin: 0,
  },
  subtitle: {
    fontSize: '0.95rem',
    color: 'var(--ka-gray-600)',
    marginTop: '0.4rem',
  },
  card: {
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(26,19,72,0.08)',
    padding: '1.5rem',
    border: '1px solid rgba(63,95,172,0.12)',
  },
  embedWrapper: {
    position: 'relative',
    paddingBottom: 'calc(56.25% + 25px)',
    width: '100%',
    height: 0,
    transform: 'scale(1)',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: '1px solid rgba(63,95,172,0.35)',
    boxShadow: '0px 0px 18px rgba(26, 19, 72, 0.15)',
    borderRadius: 10,
    boxSizing: 'border-box',
  },
};

export default function StorylanePage() {
    const navigate = useNavigate();
    const scriptLoaded = useRef(false);

  useEffect(() => {
    if (scriptLoaded.current) return;
    scriptLoaded.current = true;

    const script = document.createElement('script');
    script.src = 'https://js.storylane.io/js/v2/storylane.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up on unmount
      const existing = document.querySelector(
        'script[src="https://js.storylane.io/js/v2/storylane.js"]'
      );
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button
            onClick={() => navigate(-1)}
            style={{
                background: 'none',
                border: 'none',
                color: 'var(--ka-navy)',
                fontSize: '0.9rem',
                cursor: 'pointer',
                padding: '0 0 0.75rem 0',
                display: 'flex',
                alignItems: 'center',
                gap: '0.4rem',
                opacity: 0.7,
            }}
            >
            ← Back
        </button>
        <h1 style={styles.title}>Teams Recordings and Transcripts</h1>
        <p style={styles.subtitle}>
          Walk through the setup process at your own pace.
        </p>
      </div>

      <div style={styles.card}>
        <div className="sl-embed" style={styles.embedWrapper}>
          <iframe
            loading="lazy"
            className="sl-demo"
            src="https://app.storylane.io/demo/7zbwc1nqjorf?embed=inline"
            name="sl-embed"
            allow="fullscreen"
            allowFullScreen
            style={styles.iframe}
            title="Interactive Demo"
          />
        </div>
      </div>
    </div>
  );
}